/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig = {
    auth: {
        clientId: "60f34bd7-2163-41ac-8368-9eae9a388e78",
        authority: "https://login.microsoftonline.com/65c813d6-97d2-451a-b4b5-340abb4fb2d8",
        redirectUri: "https://autoservice.abs.kiwi"
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {	
        loggerOptions: {	
            loggerCallback: (level, message, containsPii) => {	
                if (containsPii) {		
                    return;		
                }		
                switch (level) {		
                    case LogLevel.Error:		
                        console.error(message);		
                        return;		
                    case LogLevel.Info:		
                        console.info(message);		
                        return;		
                    case LogLevel.Verbose:		
                        console.debug(message);		
                        return;		
                    case LogLevel.Warning:		
                        console.warn(message);		
                        return;		
                }	
            }	
        }	
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ["https://asm.nzta.govt.nz/user_impersonation"]
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphDirectReportsEndpoint: "https://graphapiasm.azurewebsites.net/api/directReports?code=7KtkR5f/wYKVFIUk0lJXOwBUm7E2q4n2JprPIOQr0Dkret97kVey1w==",
    graphUpdateUserEndpoint: "https://graphapiasm.azurewebsites.net/api/user/USERID?code=DkLNFKsm0MAW9ao6KXVBMQpmsUiuHi8a9QspZIyJiTE3AoXKbqogGg==",
    downloadAADInfoEndpoint: "https://graphapiasm.azurewebsites.net/api/export?code=Cf0Yau1RhAvI1YJfqdDumAIoJntFCK58XpxrNH6bTUsCh4zkEtUqyA==",
    graphRecruitmentRequestsEndpoint: "https://graphapiasm.azurewebsites.net/api/recruitmentRequests?code=xvzOyyntoMZ6uUnDeX3QYPDe5xkGaBRaTKIWwx/L7XbQ0xOg7eslNg==",
    graphGetUsersEndpoint: "https://graphapiasm.azurewebsites.net/api/users?code=jVhxB2mB2HsQlPELvH8wq4LkqyhgTVGF2mcU9llQa1fiRnHFBwDBww==",
    graphRecruitmentRequestsCreateEndpoint: "https://graphapiasm.azurewebsites.net/api/recruitmentRequests?code=l32gftsplQwiitlbRQYeJVfZmzCs2pemm5BIEVAah0KuUP9yEyEYRQ==",
    graphGetPositionsEndpoint: "https://graphapiasm.azurewebsites.net/api/positions?code=ZcGAd7j4zsTNhXwfA3GTOjoZZGVvYV5J9DGLynlIqgmDk/K7s3aIvQ==",
    graphNewStarterEndpoint: "https://graphapiasm.azurewebsites.net/api/newStarter/RECRUITMENTID?code=AkGwxbZ4ivcDbmRRUZ8VAFM0f6IPt8gAHE14AFnB240QqaCD2azLzw=="
};
